import { boolean, object, string } from "yup";

export type FormValues = {
  company: string;
  tel: string;
  name: string;
  email: string;
  itpUrls: string;
  userTag?: string;
  isCrossDomainQuery: boolean;
  isCrossDomainFragment: boolean;
  jsTagManagementEnabled: boolean;
  enableBackendUrlMapping: boolean;
  reAuthPassword: string;
};

export const validationSchema = object({
  company: string().required(),
  tel: string(),
  name: string().required(),
  email: string().email(),
  itpUrls: string().url(),
  userTag: string().notRequired(),
  isCrossDomainQuery: boolean().required(),
  isCrossDomainFragment: boolean().required(),
  jsTagManagementEnabled: boolean().required(),
  enableBackendUrlMapping: boolean().required(),
});
